module.exports = __webpack_public_path__ + "img/back-url.39471b69.png";